var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4533 31.5292C25.1699 31.9083 23.6533 32.0833 21.8741 32.0833H13.1241C11.3449 32.0833 9.82826 31.9083 8.54492 31.5292C8.86576 27.7375 12.7595 24.7479 17.4991 24.7479C22.2387 24.7479 26.1324 27.7375 26.4533 31.5292Z",
    stroke: "#3AAA35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8743 2.91666H13.1243C5.83268 2.91666 2.91602 5.83333 2.91602 13.125V21.875C2.91602 27.3875 4.57852 30.4062 8.54518 31.5292C8.86602 27.7375 12.7598 24.7479 17.4993 24.7479C22.2389 24.7479 26.1327 27.7375 26.4535 31.5292C30.4202 30.4062 32.0827 27.3875 32.0827 21.875V13.125C32.0827 5.83333 29.166 2.91666 21.8743 2.91666ZM17.4993 20.6646C14.6118 20.6646 12.2785 18.3167 12.2785 15.4292C12.2785 12.5417 14.6118 10.2083 17.4993 10.2083C20.3868 10.2083 22.7202 12.5417 22.7202 15.4292C22.7202 18.3167 20.3868 20.6646 17.4993 20.6646Z",
    stroke: "#3AAA35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.721 15.4292C22.721 18.3167 20.3876 20.6646 17.5001 20.6646C14.6126 20.6646 12.2793 18.3167 12.2793 15.4292C12.2793 12.5417 14.6126 10.2083 17.5001 10.2083C20.3876 10.2083 22.721 12.5417 22.721 15.4292Z",
    stroke: "#3AAA35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.d3e4ba7526b56fc3f676c91eacdfc876.svg";
export { ForwardRef as ReactComponent };